import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';

import { routes } from './app.routes';
import { FeatureFlagService } from './services/feature-flag/feature-flag.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideCharts(withDefaultRegisterables()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useFactory: (overlay: Overlay) => ({
        scrollStrategy: overlay.scrollStrategies.block(),
      }),
      deps: [Overlay],
    },
    // Load global feature flags before the first paint and subscribe to live
    // changes. Boot blocks on loadAll() so guards/templates see the real flag
    // state on first render rather than an empty-then-flicker.
    provideAppInitializer(() => {
      const flags = inject(FeatureFlagService);
      return (async () => {
        await flags.loadAll();
        flags.subscribeToChanges();
      })();
    }),
  ],
};
